export default {
    id: "9025df75-dbbc-4cc9-8012-dda0fbe8ee7e",
    icon: "mdi-shape",
    name: "shape",
    title: "Shape",
    description: "A block shape",
}